var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgEye2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1639_374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4195 12.0945C24.2052 11.8555 19.0525 6.23535 12.5987 6.23535C6.14481 6.23535 0.992125 11.8555 0.777859 12.0945C0.538891 12.3616 0.538891 12.7654 0.777859 13.0325C0.992125 13.2714 6.14491 18.8916 12.5987 18.8916C19.0524 18.8916 24.2052 13.2714 24.4195 13.0325C24.6584 12.7654 24.6584 12.3616 24.4195 12.0945ZM12.5987 17.4854C9.88502 17.4854 7.67678 15.2771 7.67678 12.5635C7.67678 9.84984 9.88502 7.6416 12.5987 7.6416C15.3123 7.6416 17.5205 9.84984 17.5205 12.5635C17.5205 15.2771 15.3123 17.4854 12.5987 17.4854Z",
    fill: "#A7B7DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3018 11.1572C13.3018 10.4499 13.6529 9.82762 14.1871 9.44488C13.7077 9.19949 13.1731 9.04785 12.5986 9.04785C10.6602 9.04785 9.08301 10.6251 9.08301 12.5635C9.08301 14.5019 10.6602 16.0791 12.5986 16.0791C14.3341 16.0791 15.7706 14.8119 16.0544 13.1561C14.6384 13.6119 13.3018 12.5411 13.3018 11.1572Z",
    fill: "#A7B7DD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1639_374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.598633 0.563477)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye2);
export default __webpack_public_path__ + "static/media/eye (2).40e4a1c66cc840cfc5675db9ea434291.svg";
export { ForwardRef as ReactComponent };